import { useActiveMember } from 'hooks';
import { useCallback } from 'react';
import { useFeatureFlags } from 'utils/features';

export default function useFreemiumLimitedGPS() {
  const activeMember = useActiveMember();
  const isFreemiumLimited = useFeatureFlags('FREEMIUM_LIMITED');

  return useCallback(
    (memberId: string) => {
      return isFreemiumLimited && memberId !== activeMember?.id;
    },
    [isFreemiumLimited, activeMember?.id]
  );
}
